import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { getNotification, updateNotification } from '../utils/APIs';
import { useUserContext } from '../contexts/UserContext'
import { useContentfulContext } from './ContentfulContext';

const NotificationContext = createContext({});

export const NotificationContextProvider = ({ children }) => {
    const { userData } = useUserContext();
    const activeScope = `${userData?.token || ''}:${userData?.selectedOrganization?.org_token || ''}`;
    const scopeRef = useRef(activeScope);
    scopeRef.current = activeScope;
    const { enums } = useContentfulContext();
    const [notifications, setNotifications] = useState({
        local: [],
        global: [],
        all: [],
    })
    const [notificationCount, setNotificationCount] = useState({
        globalUnreadCount: 0,
        localUnreadCount: 0,
        allCount: 0,
    })

    useEffect(() => {
        if (userData?.token && userData?.selectedOrganization?.org_token) {
            getNotificationData()
        }
    }, [userData?.selectedOrganization])

    useEffect(() => {
        if (!userData?.token || !userData?.selectedOrganization?.org_token) return;
        const interval = setInterval(() => getNotificationData(), 15000);
        return () => clearInterval(interval);
        // Refresh with the current organisation credentials.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData?.token, userData?.selectedOrganization?.org_token]);

    const getNotificationData = async () => {
        const scope = activeScope;
        try {
            const result = await getNotification(userData?.token, userData?.selectedOrganization?.org_token)
            if (scope !== scopeRef.current) return;
            if (userData?.token && userData?.selectedOrganization?.org_token) {
                setNotifications({
                    local: result.data.notifications.filter((x) => (x.type == enums?.notificationTypes.local.id)),
                    global: result.data.notifications.filter((x) => (x.type == enums?.notificationTypes.global.id)),
                    all: result.data.notifications
                })
                setNotificationCount({
                    globalUnreadCount: result.data.globalUnreadCount,
                    localUnreadCount: result.data.localUnreadCount,
                    allUnreadCount: result.data.globalUnreadCount + result.data.localUnreadCount,
                })
            }else{
                setNotifications({
                    global: result.data.filter((x) => (x.type == enums?.notificationTypes?.global?.id)),
                })
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    const refetchNotification = async () => {
        getNotificationData()
    }

    const markAsReadNotification = async (id, type) => {
        try {
            await updateNotification(userData?.token, userData?.selectedOrganization?.org_token, id, { type })
            getNotificationData()
        } catch (err) {
            console.log('err', err);
        }
    }

    const markAllAsReadNotification = async () => {
        try {
            await updateNotification(userData?.token, userData?.selectedOrganization?.org_token, "mark-all-as-read", {})
            getNotificationData()
        } catch (err) {
            console.log('err', err);
        }
    }

    return (
        <NotificationContext.Provider
            value={{
                notifications,
                getNotificationData,
                setNotifications,
                notificationCount,
                setNotificationCount,
                refetchNotification,
                markAsReadNotification,
                markAllAsReadNotification,
            }}
        >
            {children}
        </NotificationContext.Provider>
    );

}

export const useNotificationContext = () => useContext(NotificationContext);
